import { SVGProps } from 'react';
export const UntitledUICornerDownRightIcon = (
  props: SVGProps<SVGSVGElement>,
) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M5 4c0-.56-.45-1-1-1-.56 0-1 .44-1 1v1.44c-.01 1.64-.01 2.93.08 3.97.08 1.06.26 1.94.67 2.75a7.022 7.022 0 0 0 3.05 3.05c.8.41 1.69.59 2.75.67 1.04.08 2.33.08 3.97.08h4.03l-3.3 3.29c-.4.39-.4 1.02 0 1.41.39.39 1.02.39 1.41 0l5-5c.39-.4.39-1.03 0-1.42l-5-5.01a.99.99 0 0 0-1.42 0c-.4.39-.4 1.02 0 1.41l3.29 3.29h-3.99c-1.7 0-2.91-.01-3.86-.08-.94-.08-1.54-.23-2.02-.47a4.985 4.985 0 0 1-2.19-2.19c-.25-.48-.39-1.08-.47-2.02-.08-.96-.08-2.17-.08-3.86v-1.4Z" />
  </svg>
);
